import utils from '../../../../modules/utils';
import API from '../../../api/api';

function isTokenReceived(status) {
  return status === 'HOSTED_PAYMENT_TOKEN_RECEIVED';
}

function isReturningFromHostedPage() {
  return window.start.selectedPaymentMethod === 'LAYBUY';
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage(queryParams = '') {
  const {status} = utils.fn.getURIParams(queryParams);
  if (status && status.toUpperCase() === 'SUCCESS') {
    return API.doAPIRequest('/v2/return-from-hosted/laybuy');
  }
  
  return Promise.reject();
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
